<template>
  <kst-section items-mode>
    <kst-table view-mode :data="items">
      <b-table-column
        v-slot="{ column, row }"
        cell-class="kst-invoice-related-Name"
        field="Name"
        :label="InvoiceItemCatalog.Name.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column cell-class="ks-col-nopad" header-class="p-0" width="1">
        <template #header>
          <kst-header-blank />
        </template>
        <template #default="{ row }">
          <kst-tooltip info-mode>
            <template #content>
              <kst-list info-mode :items="Model.getItemInfo_Related(row)"/>
            </template>
            <kst-icon info-mode/>
          </kst-tooltip>
        </template>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-qty"
        field="RequestedQuantity"
        :label="InvoiceItemCatalog.RequestedQuantity.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column
        v-slot="{ column, row }"
        cell-class="ks-col-packaging"
        field="Packaging"
        :label="InvoiceItemCatalog.Packaging.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-price"
        field="SellPrice"
        :label="InvoiceItemCatalog.SellPrice.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
      </b-table-column>

      <b-table-column numeric
        v-slot="{ column, row }"
        cell-class="ks-col-subtotal"
        field="Price"
        :label="InvoiceItemCatalog.Price.Label"
      >
        <kst-value ellipsis :field="column.field" :data="row" :catalog="InvoiceItemCatalog"/>
      </b-table-column>
    </kst-table>
  </kst-section>
</template>

<script>
import InvoiceItemCatalog from "../InvoiceItemCatalog.js";
import Model from "../InvoiceModel.js";

export default {
  props: {
    items: Array
  },
  data: () => ({
    InvoiceItemCatalog: InvoiceItemCatalog,
    Model: Model
  })
}
</script>